export enum EmailType {
  General = 'general',
  NewUnitRequest = 'new_unit_request',
  NewMeasureRequest = 'new_measure_request',
  ErrorReport = 'error_report',
  FeatureRequest = 'feature_request'
}

export interface NewUnitRequestEmailPayload {
  email_request: {
    email_type: EmailType.NewUnitRequest
    measure: string
    unit: string
    message?: string
    sender_email?: string
  }
}

export interface NewMeasureRequestEmailPayload {
  email_request: {
    email_type: EmailType.NewMeasureRequest
    measure: string
    message?: string
    sender_email?: string
  }
}

export interface ErrorReportEmailPayload {
  email_request: {
    email_type: EmailType.ErrorReport
    message: string
    sender_email?: string
    is_error_with_conversion: boolean
    from_unit?: string
    to_unit?: string
    current_measure?: string
    from_number?: string
    to_number?: string
  }
}


export interface GenericEmailPayload {
  email_request: {
    email_type: EmailType.NewMeasureRequest
    message: string
    sender_email?: string
  }
}

export type EmailPayload =
  | NewUnitRequestEmailPayload
  | NewMeasureRequestEmailPayload
  | ErrorReportEmailPayload
  | GenericEmailPayload
